module.exports = __webpack_public_path__ + "static/media/torii-gate.b44f3e21.svg";